"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLegalSectionDto = instanceOfLegalSectionDto;
exports.LegalSectionDtoFromJSON = LegalSectionDtoFromJSON;
exports.LegalSectionDtoFromJSONTyped = LegalSectionDtoFromJSONTyped;
exports.LegalSectionDtoToJSON = LegalSectionDtoToJSON;
exports.LegalSectionDtoToJSONTyped = LegalSectionDtoToJSONTyped;
/**
 * Check if a given object implements the LegalSectionDto interface.
 */
function instanceOfLegalSectionDto(value) {
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('heading' in value) || value['heading'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
function LegalSectionDtoFromJSON(json) {
    return LegalSectionDtoFromJSONTyped(json, false);
}
function LegalSectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'slug': json['slug'],
        'heading': json['heading'],
        'body': json['body'],
    };
}
function LegalSectionDtoToJSON(json) {
    return LegalSectionDtoToJSONTyped(json, false);
}
function LegalSectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'slug': value['slug'],
        'heading': value['heading'],
        'body': value['body'],
    };
}
